import { render, staticRenderFns } from "./RecentlyDelivered.vue?vue&type=template&id=289b467a&"
import script from "./RecentlyDelivered.vue?vue&type=script&lang=js&"
export * from "./RecentlyDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports